import Vue from 'vue'
export const toastBus = new Vue()
